import HeadLine from "../headLine";
import Image from "next/image";
import { useState } from "react";
import { subscribeNewsletter } from "../../services/publicCall";
import { validateEmail } from "../../utils/validation";
import { errorToast } from "../../utils/toast";

const WeeklyDigest = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;

    const trimmedEmail = email.trim();
    if (!validateEmail(trimmedEmail)) {
      errorToast("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      await subscribeNewsletter({ email: trimmedEmail });
      setEmail("");
    } catch (error) {
      // Error toast is handled by publicApiCall.postPublic
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative py-24">
      <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
        <Image
          width={1519}
          height={935}
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full object-cover"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block">
        <Image
          width={1519}
          height={935}
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full object-cover"
        />
      </picture>

      <div className="container">
        {/* start call to action weekly digest */}
        <div className="rounded-2.5xl bg-white px-6 py-16 text-center dark:bg-jacarta-700 md:px-12 md:py-20">
          <HeadLine
            text=" Weekly Digest"
            classes="mb-5 font-display text-2xl text-jacarta-700 dark:text-white md:text-3xl"
          />

          <p className="mx-auto max-w-2xl text-center text-base text-jacarta-700 dark:text-white md:text-lg">
            Join our mailing list to stay in the loop with our newest feature
            releases, Impact Art drops, and tips and tricks for navigating
            Impactoverse
          </p>

          <div className="mx-auto mt-7 max-w-md text-center">
            <form className="sm:relative" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                className="dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-100 w-full rounded-full border py-3 px-4 dark:text-white dark:placeholder-white sm:pr-32"
              />
              <button
                type="submit"
                disabled={loading || !email}
                className="hover:bg-accent/50 font-display bg-accent mt-4 w-full rounded-full px-6 py-2 text-sm text-white sm:absolute sm:top-2 sm:right-2 sm:mt-0 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>
        </div>
        {/* end call to action weekly digest */}
      </div>
    </section>
  );
};

export default WeeklyDigest;
